<template>
    <div>
        <slot></slot>
    </div>
</template>

<script lang="ts" setup>
import type {ApiRoutes, CheckFilterValue, Dictionary} from "../types.ts";
import {KeyJobApiProvider} from "../symbols.ts";
import JobApiProvider from "../JobApiProvider.ts";
import {provide} from "vue";

interface Props {
    routes: ApiRoutes
    filters: Array<string>
    checkFilters: Array<CheckFilterValue>
    config: Dictionary<any>
    content: Dictionary<any>
}

const {routes, filters, checkFilters, config, content} = defineProps<Props>()

provide(KeyJobApiProvider, new JobApiProvider(routes, filters, checkFilters, config, content));

</script>


